module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_MU_2Bdr_D4_cam6.064a7ff3.jpg";